import React, { useEffect, useState } from "react";
import DictTagsService from "../../../../../services/dict/DictTagsService";
import { DictTagsDto } from "../../../../../types/types";

interface BodyPhotoTagsAddProps {
  onTagsSelected: (tags: { id: string; name: string }[]) => void;
  photoId: string;
}

const BodyPhotoTagsAdd: React.FC<BodyPhotoTagsAddProps> = ({ onTagsSelected, photoId }) => {
  const [tags, setTags] = useState<DictTagsDto[]>([]);
  const [selectedTags, setSelectedTags] = useState<{ id: string; name: string }[]>([]);

  useEffect(() => {
    const fetchTags = async () => {
      try {
        const response = await DictTagsService.getDictTagsForBodyPhoto(photoId);
        setTags(response.data);
      } catch (error) {
        console.error("Failed to fetch tags", error);
      }
    };

    fetchTags();
  }, []);

  const handleTagToggle = (tag: DictTagsDto) => {
    setSelectedTags((prevSelected) => {
      const isSelected = prevSelected.some((t) => t.id === tag.id);
      if (isSelected) {
        return prevSelected.filter((t) => t.id !== tag.id);
      } else {
        return [...prevSelected, { id: tag.id, name: tag.name }];
      }
    });
  };

  const handleSave = () => {
    onTagsSelected(selectedTags);
  };

  return (
    <div>
      <ul>
        {tags.map((tag) => (
          <li key={tag.id}>
            <label>
              <input
                type="checkbox"
                checked={selectedTags.some((t) => t.id === tag.id)}
                onChange={() => handleTagToggle(tag)}
              />
              {tag.name}
            </label>
          </li>
        ))}
      </ul>
      <button onClick={handleSave}>Save Tags</button>
    </div>
  );
};

export default BodyPhotoTagsAdd;
